import cls from 'classnames';
import Tooltip from '../Tooltip';
import { getIcon, isValidIcon } from './allIcons';
import styles from './styles.module.scss';
import { IconProps } from './types';

const Icon = ({
    name,
    className,
    size = 18,
    color,
    onClick,
    style,
    tips,
    side = 'top',
    ...props
}: IconProps) => {
    // 直接获取图标内容，无需异步加载
    const svgContent = getIcon(name);
    const error = !isValidIcon(name);
    
    if (error) {
        console.error(`Icon not found: ${name}`);
    }

    // 处理 SVG 内容，应用颜色
    const processSvgContent = (svgString: string, iconColor?: string) => {
        if (!iconColor) return svgString;
        
        // 使用正则表达式替换 SVG 中的 fill 和 stroke 属性
        return svgString
            .replace(/fill="[^"]*"/g, `fill="${iconColor}"`)
            .replace(/stroke="[^"]*"/g, `stroke="${iconColor}"`)
            .replace(/fill='[^']*'/g, `fill='${iconColor}'`)
            .replace(/stroke='[^']*'/g, `stroke='${iconColor}'`);
    };

    if (error || !svgContent) {
        return (
            <div 
                className={cls(styles['icon-error'], className)}
                style={{
                    width: size,
                    height: size,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f5f5f5',
                    color: '#999',
                    fontSize: '12px',
                    border: '1px dashed #ddd',
                    ...style
                }}
                {...props}
            >
                ?
            </div>
        );
    }

    // 渲染 icon 内容的函数
    const renderIconContent = () => (
        <div
            className={cls(styles.icon, onClick && styles.clickable, className)}
            style={{
                width: size,
                height: size,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                ...style
            }}
            onClick={onClick}
            {...props}
            dangerouslySetInnerHTML={{ __html: processSvgContent(svgContent, color) }}
        />
    );

    return (
        <Tooltip content={tips} side={side}>
            {renderIconContent()}
        </Tooltip>
    );
};

export default Icon;
export { ALL_ICON_NAMES, isValidIcon } from './allIcons';
export type { IconProps };

